import { render, staticRenderFns } from "./BattleModal.vue?vue&type=template&id=493f0b51&scoped=true&lang=pug&"
import script from "./BattleModal.vue?vue&type=script&lang=js&"
export * from "./BattleModal.vue?vue&type=script&lang=js&"
import style0 from "./BattleModal.vue?vue&type=style&index=0&id=493f0b51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493f0b51",
  null
  
)

export default component.exports